import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

type ElementType =
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span';

interface H5Props {
  as: string;
  children: React.ReactNode;
  dataTest: string;
}

export interface ParagraphHeaderProps {
  as?: ElementType;
  children?: React.ReactNode;
  className?: string;
  name?: string;
  maxLines?: number;
  /**
   * Breaks a word anywhere rather than only where it could. Without it a run with no space in it -
   * a url, a hash, a pasted token - is one unbreakable word: it cannot wrap, so it sets the width
   * of whatever holds it and spills out of it rather than filling the lines `maxLines` allows.
   *
   * Only read alongside `maxLines`, which is what draws the lines to be kept to.
   */
  maxLinesStrict?: boolean;
}

const H5 = ({ as, children, dataTest }: H5Props) =>
  React.createElement(as, { dataTest }, children);

const StyledH5 = styled(H5)``;

export const ParagraphHeader = ({
  as = 'h5',
  children,
  className = '',
  name,
  maxLines,
  maxLinesStrict = false,
}: ParagraphHeaderProps) => (
  <StyledH5
    as={as}
    className={AttrsHelper.formatClassname(
      'paragraph-header',
      maxLines && `max-lines-${maxLinesStrict ? 'strict-' : ''}${maxLines}`,
      className
    )}
    data-test={name}
  >
    {children}
  </StyledH5>
);
